import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';

const TOKEN_KEY = 'auth_token';

export const getToken = () => {
  return Cookies.get(TOKEN_KEY);
};

export const decodeToken = (token) => {
  try {
    return jwtDecode(token || getToken());
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const getUserRole = () => {
  const decodedToken = decodeToken();
  if (!decodedToken) return null;
  
  // Get the string role from the array (first non-UUID element)
  const role = Array.isArray(decodedToken.role) 
    ? decodedToken.role.find(r => !r.includes('-')) 
    : decodedToken.role;
    
  return role;
};

export const getUserName = () => {
  const decodedToken = decodeToken();
  return decodedToken?.unique_name || '';
};

export const getAuthHeaders = () => {
  const token = getToken();
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export const getUserId = () => {
  const decodedToken = decodeToken();
  return decodedToken?.nameid || '';
};

export const isTokenExpired = () => {
  const decodedToken = decodeToken();
  if (!decodedToken || !decodedToken.exp) return true;
  
  const currentTime = Date.now() / 1000;
  return decodedToken.exp < currentTime;
};

export const hasValidToken = () => {
  return !!getToken() && !isTokenExpired();
};
